import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { assertAuthenticated } from "@/utilities/auth/assertAuthenticated"

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: ({ context, location }) => {
    /**
     * `qrLookupID` is not in this tree's validated schema, so read it from the
     * raw query string.
     */
    const rawSearch = new URLSearchParams(location.searchStr)
    const qrLookupID = rawSearch.get("qrLookupID")

    /**
     * Legacy shim: upgrade `/account/...?qrLookupID=` links to the path-param
     * tree, preserving every other search param. It is generic over pathname,
     * so the two trees' paths must stay in step — renaming a
     * `/qr/$qrLookupID/account/*` path without its `/account/*` counterpart
     * 404s links already in the wild.
     */
    if (qrLookupID) {
      rawSearch.delete("qrLookupID")
      const query = rawSearch.toString()
      throw redirect({
        href: `/qr/${encodeURIComponent(qrLookupID)}${location.pathname}${
          query ? `?${query}` : ""
        }`,
      })
    }

    assertAuthenticated({
      isAuthenticated: context.isAuthenticated,
      redirectHref: location.href,
    })
  },
  loader: ({ context }) => {
    context.setDocumentThemeMode("root")
  },
  component: Outlet,
})
